<template>
  <div class="text-textColor">
    <transition name="fade">
      <div
        v-if="showCreateJournal"
        class="bg-black fixed bg-opacity-70 inset-0 z-50 h-screen w-full"
      >
        <form
          @submit.prevent="create"
          class="fixed max-h-screen center-h-v bg-white rounded-md shadow-2xl sm:w-2/5 w-full"
        >
          <transition name="fade">
            <div
              v-if="loading"
              class="inset-0 absolute bg-black rounded-md bg-opacity-10 w-full"
            >
              <loader class="center-h-v" />
            </div>
          </transition>
          <div
            class="flex justify-between items-center bg-white sticky top-0 border-b-1.5 p-3"
          >
            <p class="text-base">Create Time off Journal Title</p>
            <img
              class="h-6 object-contain cursor-pointer hover:shadow-lg bg-primary rounded-md"
              src="@/assets/icons/cross-white.png"
              @click="close()"
            />
          </div>
          <transition name="fade">
            <div
              v-if="create_error"
              class="p-1 text-center text-sm w-full bg-yellow-200"
            >
              {{ create_error }}
            </div>
          </transition>
          <transition name="fade">
            <div
              v-if="create_success"
              class="p-1 text-center text-white text-sm w-full bg-green-200"
            >
              {{ create_success }}
            </div>
          </transition>
          <div class="grid grid-cols-1 p-4 gap-5">
            <div class="text-sm">
              <label class="block pb-1">Code</label>
              <input
                class="p-2 bg-gray-200 rounded-full w-full border-none"
                v-model="info.Code"
              />
            </div>
            <div class="text-sm">
              <label class="block pb-1">Name</label>
              <input
                class="p-2 bg-gray-200 rounded-full w-full border-none"
                v-model="info.Name"
              />
            </div>
          </div>
          <div class="flex justify-end p-5">
            <button
              type="submit"
              class="bg-primary rounded-full px-10 text-sm text-white py-2"
            >
              Create
            </button>
          </div>
        </form>
      </div>
    </transition>
  </div>
</template>

<script>
import axios from "axios";
import { mapGetters } from "vuex";
import Loader from "@/components/loader/loader.vue";

export default {
  name: "CompanySetupCreateLocation",
  props: ["showCreateJournal", "reload"],
  components: { Loader },
  data() {
    return {
      saved_departments: [],
      country: null,
      info: {
        Name: "",
        Code: "",
      },

      leavePeriodToSelect: "",
      leaveTypeToSelect: "",
      employeeToSelect: "",
      create_error: null,
      create_success: null,
      loading: false,
      periods: [],
      leaveTypes: [],
      employees: [],
      types: ["Take On", "Negative Adjustment", "Positive Adjustment"],
    };
  },

  computed: {
    ...mapGetters(["getOrganization", "getToken"]),
  },
  created() {
    this.getPeriods();
    this.getLeaveTypes();
    this.getEmployees();
  },
  methods: {
    close() {
      this.$emit("close");
    },

    async fetchLeavePeriods(queryString, callback) {
      //console.log(this.leavePeriodToSelect)

      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        queryString = queryString.split(" ")[0];
        //console.log(queryString)
        this.leavePeriodToSelect = this.periods.filter((period) =>
          period.MonthName.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.leavePeriodToSelect.length) {
          callback([{ MonthName: "No results found" }]);
          return;
        }
        callback(this.leavePeriodToSelect);
      } else {
        callback(this.periods);
      }
    },

    findLeavePeriod(leavePeriod) {
      this.info.LeavePeriodId = leavePeriod.Id;
      this.info = {
        ...this.info,
        LeavePeriodName: `${leavePeriod.MonthName} ${leavePeriod.Year}`,
      };
    },

    async fetchLeaveTypes(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        //console.log(queryString)

        this.leaveTypeToSelect = this.leaveTypes.filter((leave) =>
          leave.Name.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.leaveTypeToSelect.length) {
          callback([{ Name: "No results found" }]);
          return;
        }
        callback(this.leaveTypeToSelect);
      } else {
        callback(this.leaveTypes);
      }
    },

    async fetchTypes(queryString, callback) {
      if (queryString) {
        this.typeToSelect = this.types.filter((type) =>
          type.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.info.Type.length) {
          callback(["No results found"]);
          return;
        }
        callback(this.typeToSelect);
      } else {
        callback(this.types);
      }
    },

    findLeaveType({ Id }) {
      this.info.LeaveTypeId = Id;
      // this.info = { ...this.info, ...leaveType }
    },
    async fetchEmployees(queryString, callback) {
      // fetch locations
      // based on the user input and call the callback function
      // with the resulting suggestions
      if (queryString) {
        //console.log(queryString)

        this.employeeToSelect = this.employees.filter((employee) =>
          employee.Fullname.toLowerCase().includes(queryString.toLowerCase())
        );

        if (queryString && !this.employeeToSelect.length) {
          callback([{ Fullname: "No results found" }]);
          return;
        }
        callback(this.employeeToSelect);
      } else {
        callback(this.employees);
      }
    },

    findEmployee(employee) {
      // this.info = { ...this.info, ...leaveType }
      this.info.EmployeeId = employee.Id;
    },
    setCountryName(country) {
      this.info.Country = country.Name;
    },
    // /{organization}/timeoff/journal/v1/create
    create() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
          "Content-Type": "application/json",
        },
      };
      axios
        .post(
          `${this.getOrganization}/timeoff/journal/${this.$ApiVersion}/create`,
          JSON.stringify(this.info),
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.$notify.success({
                title: "Success",
                message: response.data.StatusMessage,
              });
              this.info = {
                Name: "",
                Code: "",
              };

              this.create_success = null;
              this.close();
              this.$emit("closeOnSuccess");
              this.reload();
            } else {
              this.$notify.error({
                title: "Failure",
                message: response.data.StatusMessage,
              });
            }
          },
          (error) => {
            this.loading = false;

            this.$notify.success({
              title: "Failure",
              message: error.message,
            });
          }
        );
    },
    // /{organization}/setup/leave/period/v1/request
    getPeriods() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leave/period/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              //console.log(response.data.Data);
              this.periods = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },

    getLeaveTypes() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/setup/leavetype/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.leaveTypes = response.data.Data.map((row) => {
                return { ...row, showActions: false };
              });
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
    // /{organization}/employee/all/v1/request
    getEmployees() {
      this.loading = true;
      const options = {
        headers: {
          Authorization: `Bearer ${this.getToken}`,
        },
      };
      axios
        .get(
          `${this.getOrganization}/employee/all/${this.$ApiVersion}/request`,
          options
        )
        .then(
          (response) => {
            this.loading = false;
            if (response.data.StatusCode == 200) {
              this.employees = response.data.Data;
            } else {
              this.get_error = response.data.StatusMessage;
            }
          },
          (error) => {
            this.loading = false;
            this.get_error = error.message;
          }
        );
    },
  },
};
</script>

<style scoped>
.center-h-v {
  position: absolute;
  top: 50%;
  left: 50%;
  -ms-transform: translate(-50%, -50%);
  transform: translate(-50%, -50%);
}
</style>
